import { WebPlugin } from '@capacitor/core';

import type { BestShot, LunaSDKPlugin } from './definitions';

export class LunaSDKWeb extends WebPlugin implements LunaSDKPlugin {
  async initialize(): Promise<any> {
    throw this.unimplemented('Not implemented on web.');
  }
  async start(): Promise<BestShot> {
    throw this.unimplemented('Not implemented on web.');
  }
}
